import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'

import SwipeableDrawer from '@mui/material/SwipeableDrawer'

import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  paper: {
    width: '100%',
    boxShadow: 'none',
  },
}))

const SwipeDrawer = (props) => {
  const classes = useStyles(props)
  const {
    open,
    toggleDrawer,
    children,
    enableBackdropClick = true,
    className,
    rootClass,
    paperClass,
    anchor = 'left',
    dataQsId,
  } = props

  return (
    <SwipeableDrawer
      classes={{ root: rootClass, paper: clsx(classes.paper, paperClass) }}
      anchor={anchor}
      transitionDuration={400}
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' || enableBackdropClick) {
          toggleDrawer()
        }
      }}
      onOpen={toggleDrawer}
      BackdropProps={{ invisible: true }}
      data-qs-id={dataQsId}
    >
      <div className={className}>
        {children}
      </div>
    </SwipeableDrawer>
  )
}

SwipeDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  enableBackdropClick: PropTypes.bool,
  noHeader: PropTypes.bool,
  dataQsId: PropTypes.string.isRequired,
  rootClass: PropTypes.string,
}

export default SwipeDrawer
